import { inject, Injectable } from '@angular/core';
import { ContextService } from '@bcef/ia-shared';
import { WA_WINDOW } from '@ng-web-apis/common';

import { CustomWindowResilContrats } from '../interfaces';

@Injectable({
  providedIn: 'root',
})
export class ConnectionContextService {
  private readonly windowRef = inject<CustomWindowResilContrats>(WA_WINDOW);

  private readonly contextService: ContextService = inject(ContextService);

  public get isConnected(): boolean {
    if (this.contextService.isMobile) {
      const parsedUrl = new URL(this.windowRef.location.href);
      const connectedParam = parsedUrl.searchParams.get('connected');

      return connectedParam === 'true';
    } else {
      return this.windowRef.GlobalSite?.isConnected || false;
    }
  }
}
